<template>
    <div>
        <div v-if="showParcelas">
            <h1 id="descricao-parcelas" aria-label="Parcelas da dívida." tabindex="-1"></h1>
            <div class="text-center mb-3" aria-label="Escolher: colocar em dia, quitar ou pagar algumas.">
                <v-btn-toggle mandatory v-show="!todasParcelasObrigatorias">
                    <v-btn id="btnEmDia" aria-label="Colocar em dia" class="bg-azulSec-light acessibilidade" style="font-size:12px" @click="emDia()">Colocar <br v-if="small"> em dia</v-btn>
                    <v-btn aria-label="Quitar" class="bg-verde-light acessibilidade" @click="quitar()">Quitar</v-btn>
                    <v-btn aria-label="pagar algumas" class="bg-roxo-light acessibilidade" style="font-size:12px" @click="pagarAlgumas()">Pagar <br v-if="small"> algumas</v-btn>
                </v-btn-toggle>
            </div>
            <!-- <div aria-label="Lista de parcelas"> -->
                <!-- <div  role="presentation" class="elemento-pai">
                    <div role="presentation" class="elemento-filho contrasteExtra"> -->
                    <center-element aria-label="Lista de parcelas" role="presentation" class="contrasteExtra">
                        <v-card class="contrasteExtra px-0 no-outline" style="min-width: 295px">
                            <blockquote class="text-center blockquote acessibilidade" v-if="items.length === 0">Não há parcelas em aberto para esta dívida.</blockquote>
                            <v-list role="list" id="cardParcela" class="contrasteExtra" style="width: 100%">
                                <div role="listitem" v-for="(item,i) in items" :key="i"> 
                                    <div role="group">         
                                        <v-list-tile  class="tempParcela" >
                                            <v-list-tile-action class="mr-3" style="min-width:30px">
                                                <v-btn class="cl-azul-dark mt-0" v-show="item.check" icon @click="calculaValor(item,i)" :disabled="item.disabled"><i class="fas fa-check-square"></i></v-btn>
                                                <v-btn class="cl-azul-dark mt-0" v-show="!item.check" icon @click="calculaValor(item,i)" :disabled="item.disabled"><i class="far fa-square"></i></v-btn>
                                            </v-list-tile-action>
                                            <v-list-tile-content >
                                                <table role="grid" style="width: 100%;">                            
                                                    <tbody>
                                                        <tr role="row"> 
                                                            <td role="gridcell" :aria-label="'Valor ' + item.VrParcela + '.'" class="text-left " style="font-size: 14px;border: none">R${{item.VrParcela | formataValor}}</td>
                                                            <td role="gridcell" :aria-label="'Data ' + item.DtVencimento + '.'" class="text-right " style="font-size: 14px;border: none ">{{item.DtVencimento}}</td>
                                                        </tr>
                                                        <tr role="row">
                                                            <td role="gridcell" :aria-label="'Parcela: ' + item.SqParcela + '.'" class="" style="font-size: 14px;border: none">Parcela {{item.SqParcela}}</td>
                                                            <td role="gridcell" :aria-label="item.Atraso + ' dias de atraso.'" class="text-right " style="font-size: 14px;border: none">{{item.Atraso}} dias</td>
                                                        </tr>
                                                    </tbody>
                                                </table>        
                                            </v-list-tile-content>
                                        </v-list-tile>
                                        <v-divider aria-hidden="true" class="borderWhite" v-if="i < items.length-1" :key="`divider-${i}`"></v-divider>
                                    </div>
                                </div>
                            </v-list>
                        </v-card>
                        <div class="mt-2">
                            <h5 class="acessibilidade">Total selecionado: R${{totalSelecionado | formataValor}}</h5>
                        </div>
                        <div aria-label="Botão a direita: Negociar." style="">
                            <v-btn @click="negociar()" class="right bg-verde-dark" :disabled="parcelasAPagar.length===0">Negociar</v-btn>
                        </div>
                    </center-element>
                    <!-- </div>
                </div> -->
            <!-- </div> -->
        </div>
        <div v-else  >
            <div v-if="chaveNegociacao == undefined">
                <form>
                    <div :class="{'row col-md-12': !small}">
                        <div  :class="{'col-md-6': !small}">
                            <div class="content">
                                <div class="form-group mb-0 pa-3">
                                    <h5 class="text-center colorLabel mb-2">Forma de pagamento</h5>
                                    <div class="text-center mb-3" >
                                        <v-btn-toggle mandatory>
                                            <v-btn class="bg-azulSec-light" @click="clickFormaPgto(1)">Boleto</v-btn>
                                            <v-btn class="bg-verde-light" style="font-size:12px" v-show="divida.Produto.PermiteAcordoCartao" @click="clickFormaPgto(2)">Cartão <br v-if="small"> de crédito</v-btn>
                                            <!-- <v-btn class="bg-roxo-light" style="font-size:12px" @click="clickFormaPgto(3)">Cartão <br v-if="small"> de débito</v-btn> -->
                                        </v-btn-toggle>
                                    </div>
                            </div>
                            </div>
                            <div class="content">
                                <div class="form-group pa-3">
                                    <label id="label-atualizado" for="valor" class="colorLabel">Valor atualizado</label>
                                    <div class="input-group input-group-lg" style="width: 180px">
                                        <input 
                                        aria-labelledby="label-atualizado"
                                        id="valor"
                                        class="form-control"
                                        type="text"
                                        v-model="vrAtualizado"
                                        v-money="money"
                                        disabled
                                        >
                                    </div>
                                </div>
                                <div class="form-group pa-3" v-if="items[0].PermiteEntrada">
                                    <label id="label-entrada" for="entrada" class="colorLabel">Entrada diferenciada</label>
                                    <div class="input-group input-group-lg" style="width: 180px">
                                        <input
                                        aria-labelledby="label-entrada"
                                        id="entrada"
                                        class="form-control"
                                        type="text"
                                        :disabled="formaPgt === 2"
                                        v-model="vrEntrada"
                                        v-money="boolMoney ? money : ''"
                                        @focus="clearMoneyEntrada()"
                                        @input="boolMoney = true"
                                        >
                                    </div>
                                </div>

                            </div>
                            <div class="content">
                                <div class="form-group">
                                    <h6 class="colorLabel">Data do primeiro vencimento</h6>

                                    <v-menu
                                    v-model="menuData"
                                    :nudge-left="200"
                                    lazy
                                    transition="scale-transition"
                                    offset-x
                                    :disabled="formaPgt === 2"
                                    full-width
                                    max-width="290px"
                                    min-width="290px"
                                    tabindex="0"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <div class="input-group input-group-lg" v-on="on">
                                                <input 
                                                class="form-control"
                                                type="text"
                                                v-model="dateFormat"
                                                :disabled="formaPgt === 2"
                                                v-mask="'##/##/####'"
                                                style="max-width: 170px"
                                                @focus="focoData()"
                                                
                                                >
                                                <div class="input-group-append pointer">
                                                    <div class="input-group-text">
                                                        <i class="fas fa-calendar-day"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <div class="teste">
                                            <v-date-picker id="datePicker" tabindex="0" v-model="date"  no-title @change="formataData()" :min="dtAtual" :max="dtLimite" locale="pt-br"></v-date-picker>
                                        </div>
                                    </v-menu>
                                </div>
                            </div>
                            <div class="content">
                                <div class="form-group" >
                                    <div role="radiogroup">
                                        <input id="check1" role="radio" type="radio" :value="1" v-model="tpParcela" @change="tipoParcela()" :aria-checked="tpParcela === 1 ? true : false">
                                        <label for="check1" class="pa-2 colorLabel">Consultar por quantidade de parcela</label> 
                                        <br>
                                        <input id="check2" role="radio" type="radio" :value="2" v-model="tpParcela" @change="tipoParcela()" :aria-checked="tpParcela === 2 ? true : false">
                                        <label for="check2" class="pa-2 colorLabel"> Consultar por valor da parcela</label>
                                    </div>
                                </div>
                            </div>
                            <div class="content" v-show="tpParcela !== 0">
                                <div class="form-group pa-2" v-show="tpParcela === 2">
                                    <label for="vrParcela" class="colorLabel">Valor por parcela</label>
                                    <div class="input-group input-group-lg">
                                        <input 
                                        id="vrParcela"
                                        class="form-control"
                                        type="text"
                                        v-model="vrParcela"
                                        v-money="money"
                                        >
                                    </div>
                                </div>
                                <div class="form-group pa-2" v-show="tpParcela === 1">
                                    <label for="qtParcela" class="colorLabel">Quantidade de parcelas</label>
                                    <div class="input-group input-group-lg">
                                        <input
                                        id="qtParcela"
                                        v-mask="'###'"
                                        class="form-control"
                                        type="text"
                                        v-model="qtdParcelas"
                                        >
                                    </div>
                                </div> 
                            </div>  
                            <div class="content">
                                <v-btn @click="voltarParcelas()">
                                    <i class="fas fa-arrow-left pr-2 corIconesToolbar"></i>  Voltar
                                </v-btn>
                                <v-btn class="text-center bg-amarelo-light mb-2" @click="consultarForma(false)">
                                    <i class="fas fa-search mr-3"></i>
                                    Simular Negociação 
                                </v-btn>
                            </div>
                        </div>
                        <div class=" mt-2" :class="{'col-md-6': !small}" v-show="showOpPagamento">
                                <div >
                                    <v-card>
                                        <v-subheader id="header-list" tabindex="-1">Escolha a melhor opção:</v-subheader>
                                        <div role="list">
                                            <div
                                            role="listitem"
                                            v-for="(item,i) in listOpcoesPagamento" 
                                            :key="i"
                                            v-bind:class="{'blue lighten-5': item == opcaoAcordo, 'contrast-bk-yellow': item == opcaoAcordo }"
                                            >
                                                <div  class="header-panel pointer" @click="escolheParcela(item)">
                                                    <v-btn icon @click.stop="item.expand = !item.expand"><i class="fas fa-info-circle " style="font-size: 1.5em"></i></v-btn>
                                                    <div >
                                                        <h5>{{item.descricaoAcordo}}</h5>
                                                        <h6>Primeiro pagamento em: {{item.dtPrimeiroVencimento}}</h6>
                                                    </div>
                                                    <input style="margin-left: auto" type="radio" :value="item" v-model="opcaoAcordo">
                                                </div>
                                                <transition name="fade">
                                                    
                                                    <table v-show="item.expand"  class="table table-contrast" style="background-color: white">
                                                        <tbody >
                                                            <tr>
                                                                <td>Plano Escolhido</td>
                                                                <td class="text-right">{{item.descricaoAcordo}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Primeira Parcela</td>
                                                                <td class="text-right">{{item.dtPrimeiroVencimento}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Valor Principal</td>
                                                                <td class="text-right" >{{item.descontos ? item.descontos.principal.valorDevido : '' | formataValor}}</td>
                                                            </tr>   
                                                            <tr>
                                                                <td>Multa (+)</td>
                                                                <td class="text-right">                                                                    
                                                                    <div>{{item.descontos ? item.descontos.multa.valorDevido : '' | formataValor}}</div>
                                                                    <div class="cl-color-red font-size-2"  v-if="item.descontos.multa.valor > 0">-{{item.descontos ? item.descontos.multa.valor : '' | formataValor}}</div>
                                                                </td>
                                                            </tr>    
                                                            <tr>
                                                                <td>Juros (+)</td>
                                                                <td class="text-right">
                                                                    <div>{{item.descontos ? item.descontos.juros.valorDevido : '' | formataValor}}</div>
                                                                    <div class="cl-color-red font-size-2" v-if="item.descontos.juros.valor > 0">-{{item.descontos ? item.descontos.juros.valor : '' | formataValor}}</div>
                                                                </td>
                                                            </tr>    
                                                            <tr>
                                                                <td>Correção (+)</td>
                                                                <td class="text-right">{{item.descontos ? item.descontos.correcao.valorCobrado : '' | formataValor}}</td>
                                                            </tr>  
                                                            <tr>
                                                                <td>Valor Devido</td>
                                                                <td class="text-right">{{item.descontos ? item.descontos.totalDevido : '' | formataValor}}</td>
                                                            </tr>   
                                                            <tr>
                                                                <td>Descontos (-)</td>
                                                                <td class="text-right">{{item.descontos ? item.descontos.totalDescontos : '' | formataValor}}</td>
                                                            </tr>    
                                                            <tr>
                                                                <td>Tarifa de Postagem (+)</td>
                                                                <td class="text-right">{{item.TarifaPostagem | formataValor}}</td>
                                                            </tr>    
                                                            <tr>
                                                                <td>CET</td>
                                                                <td class="text-right">{{item.CET | formataValor}}</td>
                                                            </tr>    
                                                            <tr>
                                                                <td>{{item.descontos ? item.descontos.TAC.nome : 'Outros'}} (+)</td>
                                                                <td class="text-right">{{item.descontos.TAC.valor | formataValor}}</td>
                                                            </tr>    
                                                            <tr>
                                                                <td>Taxa de Cartão</td>
                                                                <td class="text-right">{{item.outros | formataValor}}</td>
                                                            </tr>    
                                                            <tr>
                                                                <td>Total do Acordo</td>
                                                                <td class="text-right">{{item.valorTotal | formataValor}}</td>
                                                            </tr>                                                                                      
                                                        </tbody>
                                                    </table>
                                                </transition>
                                                <v-divider aria-hidden="true" class="borderWhite mt-0 mb-0" v-if="i < items.length-1" :key="`divider-${i}`"></v-divider>
                                            </div>
                                        </div>
                                    </v-card>
                                        <center-element>
                                            <Cartao  v-if="opcaoAcordo.credito" :card="card" style="max-width: 500px"></Cartao>
                                        </center-element>
                                    <v-btn class="my-3 " v-bind:class="{'myCenter': small, 'right': !small}" color="success" @click.stop="fecharAcordo()">
                                        Fechar acordo <i class="fas fa-check ml-2"></i>
                                    </v-btn>
                                    
                                </div>
                        </div>
                    </div>
                </form>
            </div>
            <DetalhesAcordo v-if="showDetalhesAcordo" :chave="chaveNegociacao" :divida="divida" :small="small" :acordoCredito="acordoCredito"></DetalhesAcordo>
        </div>
        <v-dialog v-model="activeDialog" >
            <v-card>
                <h3 class="headline grey lighten-2 pa-3">
                    Deseja formalizar o acordo?
                    <v-btn class="right" aria-label="Fechar" icon @click="activeDialog = false" style="margin-top: -5px"><i class="fas fa-times fa-2x" style="color: grey "></i></v-btn>
                </h3>
                <v-card-text  >
                    <h5>Termo de acordo para prosseguir:</h5>
                    <center-element class="pt-3">
                        <div class=" scroll-y scroll-x style-teste"  style="max-width: 900px">
                            <div role="document" id="termo"></div>
                        </div>
                    </center-element>
                    <v-divider></v-divider>
                    <div class="content-end">
                        <v-btn color="error"  @click="activeDialog = false" small>Cancelar</v-btn>
                        <v-btn color="success" @click="formaPgt == 2 ? autorizacaoCredito() : formalizarAcordo()" small>Concordar e prosseguir</v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>


    </div>

</template>
<script>
/* eslint-disable */
import $ from 'jquery'
import DetalhesAcordo from './DetalhesAcordo'
import Vuex from '@/vuex/store'
import bus from '@/service/bus'
import moment from 'moment'
import {getDivida_Parcela, getOpAcordo, getOpAcordoPorValor, postAcordo, getValoresDevido, postBaixaAcordoCartao} from '@/service/service_autoatendimento/autoatendimento'
import {postBoletaEmail} from '@/service/service_autoatendimento/boleta'
import {postAutorizacao, postCaptura, postCancelamento} from '@/service/service_pagamento/pagamento'
import { getTermoAcordo } from '@/service/service_autoatendimento/documento'
import { formataNumeroG } from '@/global'
import Cartao from './MyComponents/Cartao'
import CenterElement from './MyComponents/CenterElement.vue'
import { setTimeout } from 'timers';
export default {
    components: { Cartao, CenterElement, DetalhesAcordo },
    props: ['divida'],
    data() {
        return {
            todasParcelasObrigatorias: false,
            validarFormaCredito: false,
            tpParcela: 1,
            activeDialog: false,
            chaveDivida: '',
            date: new Date().toISOString().substr(0, 10),
            dateFormat: moment().format('DD/MM/YYYY'),
            formaPgt: 1,
            qtdParcelas: '',
            vrEntrada: '',
            vrParcela: 0,
            vrAtualizado: 0,
            valor: 0,
            menuData: false,
            showParcelas: true,
            showOpPagamento: false,
            items: [],
            totalSelecionado: '',
            parcelasAPagar: [],
            boolMoney: false,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$',
                suffix: '',
                precision: 2,
                masked: false /* doesn't work with directive */
            },
            moneyTeste: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 0,
                masked: false /* doesn't work with directive */
            },
            listOpcoesPagamento: [],
            opcaoAcordo:'',
            card: {
                cardName: "",
                cardNumber: "",
                cardMonth: "",
                cardYear: "",
                cardCvv: "",
                type: "",
                codType: 0,
                niceType: "",
                // responsa: "",
                config: ''
            },
            idAutho: '',
            authorizationCode: '',
            dtAtual: moment().format('YYYY-MM-DD'),
            dtLimite: moment(this.divida.DtPrazoMaximo, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            expand: false,
            chaveNegociacao: undefined,
            showDetalhesAcordo: false,
            acordoCredito: false
        }
    },
    computed: {
        small(){
            return !Vuex.state.large
        },
        moneyEntrada() {
            if(this.boolMoney) return this.money
            else return ''
        }
    },
    mounted(){
        window.fonte('negociacao')
        if(window.innerWidth >= 750)  Vuex.commit('SET_TELA', true)        
        window.onresize = ()=>{
        if(window.innerWidth >= 750) Vuex.commit('SET_TELA', true)  
        else Vuex.commit('SET_TELA', false)  
        }
        this.chaveNegociacao = undefined
        this.carregaParcelas()
        
    
    },
    watch: {
        menuData: function() {
            if(!this.menuData) {
                document.getElementById('check1').focus()
            }
        }
    },
    methods:{
        focoData() {
            this.menuData = true
            // console.log(picker)
            setTimeout(() => {
                let picker = document.getElementById('datePicker')
                picker.focus()
            }, 500)
        },
        // blurData() {
        //     let radio = document.getElementById('check1')
        //     console.log(radio)
        //     radio.focus()
        // },
        tipoParcela(){
            this.qtdParcelas = 1
            this.vrParcela = 0 
        },
        carregaParcelas(){
            bus.$emit('load-in', {text: 'Carregando'})
            this.totalSelecionado = 0
            let count = 0
            getDivida_Parcela(this.divida.ChaveDivida).then((response)=>{
                this.items = response.data.Retorno.map((item, index)=>{
                    item.check = false
                    item.disabled = false

                    
                    if(item.Obrigatorio){ // se a parcela for obrigatória, insere na lista de parcelasAPagar
                        count++
                        item.check = true
                        this.parcelasAPagar.push(item)
                        item.disabled = true
                        this.totalSelecionado += item.VrParcela

                        
                        if (!item.PermiteSaltar){ // se a parcela não permite saltar, inclui a parcela anterior
                            if(index>0){
                                response.data.Retorno[index-1].check = true
                                this.parcelasAPagar.push(response.data.Retorno[index-1])
                                this.totalSelecionado += item.VrParcela
                            }
                        }
                    }
                    return item
                })

                if(count == this.items.length) this.todasParcelasObrigatorias = true
                // setTimeout(() => {
                    let d = document.getElementById('descricao-parcelas')
                    d.focus()

                // },5000)
                this.emDia()
                this.eventos()
                bus.$emit('load-out')
            }).catch(()=>{
                bus.$emit('load-out')
            })
        },
        emDia() {
            // insere na lista parcelasAPAgar as que a data e vencimento é menor que a atual ou se for obrigatória
            this.totalSelecionado = 0
            this.parcelasAPagar = []
            for(let i=0; i<this.items.length; i++){
                var data = moment(this.items[i].DtVencimento, 'DD/MM/YYYY').format('YYYY-MM-DD')
                var atual = moment().format('YYYY-MM-DD')
                if(moment(data).isBefore(atual) || this.items[i].Obrigatorio) { 
                    this.items[i].check = true
                    this.totalSelecionado += this.items[i].VrParcela
                    this.parcelasAPagar.push(this.items[i])
                } else this.items[i].check = false
            }
            
        },
        quitar() {
            // insere na lista todas as parcelas
            this.totalSelecionado = 0
            this.parcelasAPagar = this.items.map(it => {
                it.check = true
                this.totalSelecionado += it.VrParcela
                return it
            })
        },
        pagarAlgumas(){
            // insere as parcelas obrigatórias e a anterior de uma que não permite saltar
            this.totalSelecionado = 0
            this.parcelasAPagar = []
            for(let i=0; i<this.items.length; i++){
                this.items[i].check = false
                if(this.items[i].Obrigatorio) {
                    for(let j=i; j>0;j--){
                        if (!this.items[j].PermiteSaltar){
                            this.items[j-1].check = true
                            // this.parcelasAPagar.push(this.items[j-1])
                            // this.totalSelecionado += this.items[j-1].VrParcela
                        }
                    }
                    this.items[i].check = true
                    this.parcelasAPagar.push(this.items[i])
                    this.totalSelecionado += this.items[i].VrParcela
                }
            }           
            console.log(this.parcelasAPagar)
        },
        calculaValor(item, ind){
            item.check = !item.check
            if(item.check){
                for(let j=ind; j>0; j--){
                    // caso a parcela não permita saltar, insere a parcela anterior, e assim, sucessivamente.
                    if(!this.items[j].PermiteSaltar){
                        this.items[j-1].check = true
                        let index = this.parcelasAPagar.findIndex(p => p.Atraso === this.items[j-1].Atraso)
                        if(index<0){
                            this.parcelasAPagar.push(this.items[j-1])
                            this.totalSelecionado += this.items[j-1].VrParcela                          

                        }
                    }
                }
                this.items[ind].check = true
                this.parcelasAPagar.push(this.items[ind])
                this.totalSelecionado += this.items[ind].VrParcela
            } else {
                var passou = true  
                for(let j=ind; j<(this.items.length-1); j++){  
                    if(!this.items[j+1].PermiteSaltar){ // valida se a parcela posterior permite saltar, e assim sucessivamente
                        if(this.items[j+1].Obrigatorio){ // valida se a parcela não permite saltar e é obrigatória
                            passou = false // caso entre no if, não deixa desmarcar a parcela clicada e marca as que já foram desmarcadas
                            for(let l=j+1; l>ind; l--) {
                                this.items[l].check = true
                                let indexVal = this.parcelasAPagar.findIndex(t=> t.Atraso === this.items[l].Atraso)
                                if(indexVal<0){ // insere na lista se já não estiver
                                    this.parcelasAPagar.push(this.items[l])
                                    this.totalSelecionado += this.items[l].VrParcela
                                }
                            }                            
                        } else {
                            this.items[j+1].check = false
                            let k = this.parcelasAPagar.findIndex((r)=> r.Atraso === this.items[j+1].Atraso)
                            if(k>=0){ // tira da lista se existir na mesma
                                this.totalSelecionado -= this.parcelasAPagar[k].VrParcela                         
                                this.parcelasAPagar.splice(k,1)
                            }
                        }
                    }
                }
                // só desmarca se não tiver uma que não permite saltar e obrigatória nas posições posteriores
                if(passou){
                    let k = this.parcelasAPagar.findIndex((r)=> r.Atraso === item.Atraso)
                    this.parcelasAPagar.splice(k,1)
                    this.totalSelecionado -= item.VrParcela

                } else {
                    this.items[ind].check = true
                }
            }
        },
        negociar(){
            this.valor = Number((this.totalSelecionado * 100).toFixed('2'))
            this.vrEntrada = ''
            this.boolMoney = false
            this.formaPgt = 1,
            this.qtdParcelas = 1
            this.vrParcela = ''
            Vuex.commit('SET_OP_ACORDO', [])
            setTimeout(() => {
                document.getElementById('entrada').focus()
            }, 100)
            this.consultarValorDevido()
            // this.consultarForma(true)
        },
        clearMoneyEntrada() {
            this.vrEntrada = ''
            this.boolMoney = false
        },
        voltarParcelas() {
            this.showParcelas = true
            this.showOpPagamento = false
            this.listOpcoesPagamento = []
            // setTimeout(() => {

            //     document.getElementById('btnEmDia').focus()
            // }, 100)
        },
        // abrirDatePicker(){
        //     this.date = moment(this.dateFormat, 'DD/MM/YYYY').format('YYYY-MM-DD')
        //     if(this.date == 'Invalid date' || this.dateFormat.length != 10) {
        //         bus.$emit('alert-danger', 'Data inválida.')
        //         return
        //     }
        //     this.menuData = !this.menuData
        // },
        formataData(){
            
            this.dateFormat = moment(this.date, 'YYYY-MM-DD').format('DD/MM/YYYY')
        },
        clickFormaPgto(num) {
            console.log('clickFormaPgto', num)
            if (num == 2) this.dateFormat = moment().format('DD/MM/YYYY')
            this.formaPgt = num
            console.log('this.dateFormat', this.dateFormat, this.formaPgt)
            // this.opcaoAcordo = ''

        },
        opAcordoIgual() {
            let opAcordos = Vuex.state.opAcordo
            let inCartao = this.formaPgt === 2
            console.log(opAcordos, inCartao)
            let i = opAcordos.findIndex(item => {
                console.log('o erro ta aq', this.vrParcela, item.vrParcelasDesejado)
                return this.qtdParcelas == item.qtdParcelas 
                        && Number(this.vrEntrada.slice(2).replace('.','').replace(',','.')) == item.valorEntrada 
                        && Number(this.vrParcela.slice(2).replace('.','').replace(',','.')) == item.vrParcelasDesejado
                        && Number(this.vrParcela.slice(2).replace('.','').replace(',','.')) == item.vrParcelasDesejado
                        && moment(this.dateFormat, 'DD/MM/YYYY').format('DDMMYYYY') == item.data
                        && item.acordoCartaoCredito == inCartao
            })
            if(i>=0) return true
            return false
            
        },
        consultarValorDevido() {
            if(this.vrEntrada == '') this.vrEntrada = '0,00'
            let obj = {
                chaveDivida: this.divida.ChaveDivida,
                qtdParcelas: this.qtdParcelas,
                parcelasOriginais:this.parcelasAPagar[0].SqParcela.toString(),
                valorEntrada: Number(this.vrEntrada.slice(2).replace('.','').replace(',','.')),
                vrParcelasDesejado:  Number(this.vrParcela.slice(2).replace('.','').replace(',','.')),
                acordoCartaoCredito: false,
                data: moment(this.dateFormat, 'DD/MM/YYYY').format('DDMMYYYY')
            }

            

            for(let i = 1;i<this.parcelasAPagar.length; i++){
                obj.parcelasOriginais += ',' + this.parcelasAPagar[i].SqParcela
            }
            bus.$emit('load-in', {text: 'Carregando'})

            getValoresDevido(obj).then(response => {
                this.vrAtualizado = formataNumeroG(response.data.Retorno[0].descontos.totalDevido, '2', ',','.')
                this.showParcelas = false
                console.log('response.data.Retorno[0].dtPrimeiroVencimento', response.data.Retorno[0].dtPrazoMaximoCorrigirAte)
                this.dtLimite = moment(response.data.Retorno[0].dtPrazoMaximoCorrigirAte, 'DD-MM-YYYY').format('YYYY-MM-DD')

                // this.consultarForma(true)
            }).catch(() => {
                bus.$emit('load-out')
            })
            this.consultarForma(true)
            
        },
        consultarForma(origemMounted){

            if(this.opAcordoIgual()) {
                this.$swal({
                    text: 'Simulação já realizada. Mude algum parâmetro para pesquisar uma opção diferente.',
                    type: 'warning'
                })
                return
            }
            // this.opcaoAcordo = ''
            this.validarFormaCredito = false
            bus.$emit('close-alert')
            if(!origemMounted) {
                let d  = document.getElementById('header-list')
                d.focus()
                if((isNaN(this.qtdParcelas) || this.qtdParcelas == 0) && this.vrParcela == 'R$0,00'){
                    bus.$emit('alert-danger', 'Preencha o campo de valor por parcelas ou o campo de quantidade de parcelas.')
                    bus.$emit('load-out')
                    return
                }
                this.date = moment(this.dateFormat, 'DD/MM/YYYY').format('YYYY-MM-DD')
                let atual = moment().format('YYYY-MM-DD') // para não considerar a hora na comparação
                if(this.date == 'Invalid date' || this.dateFormat.length != 10) {
                    bus.$emit('alert-danger', 'Data inválida.')
                    return
                }
                if(moment(atual, 'YYYY-MM-DD').isAfter(moment(this.date, 'YYYY-MM-DD'))) {
                    bus.$emit('alert-danger', 'Data precisa ser igual ou maior que à atual.')
                    return
                }
            }
            bus.$emit('load-in', {text: 'Carregando'})
            if(this.vrEntrada == '') this.vrEntrada = '0,00'
            let obj = {
                chaveDivida: this.divida.ChaveDivida,
                qtdParcelas: this.qtdParcelas,
                parcelasOriginais:this.parcelasAPagar[0].SqParcela.toString(),
                valorEntrada: Number(this.vrEntrada.slice(2).replace('.','').replace(',','.')),
                vrParcelasDesejado:  Number(this.vrParcela.slice(2).replace('.','').replace(',','.')),
                acordoCartaoCredito: false,
                data: moment(this.dateFormat, 'DD/MM/YYYY').format('DDMMYYYY')
            }

            

            if(this.formaPgt === 2) obj.acordoCartaoCredito = true
            for(let i = 1;i<this.parcelasAPagar.length; i++){
                obj.parcelasOriginais += ',' + this.parcelasAPagar[i].SqParcela
            }
            if(this.tpParcela === 1) {
                getOpAcordo(obj).then(response => {
                    console.log(response)
                    let temp = JSON.parse(JSON.stringify(Vuex.state.opAcordo))
                    temp.push(obj)
                    Vuex.commit('SET_OP_ACORDO', temp)

                    if(response.data.Retorno.length === 0) {
                        this.errorFormaPagt()
                        bus.$emit('load-out')
                        return
                    }
                    let array = response.data.Retorno.map(item =>{
                        item.active = false
                        item.expand = false
                        if(obj.acordoCartaoCredito) item.credito = true
                        else item.credito = false
                        return item
                    })
                    //validação de entrada

                    
                    if(obj.valorEntrada > 0) {
                        if(Number(obj.qtdParcelas) > 1) {
                            let calc = array[0].descontos.TAC.valor + array[0].descontos.valorAcrescimoCobrado
                            if(obj.valorEntrada < calc) {
                                obj.valorEntrada = 0
                                this.vrEntrada = '0,00'
                                this.$swal({
                                    text: `Nestas condições o valor mínimo de entrada é de R$ ${formataNumeroG(calc, '2', ',','.')}.`,
                                    type: 'warning'
                                })
                                bus.$emit('load-out')
                                return

                            }
                        } else {
                            obj.valorEntrada = 0
                            this.vrEntrada = '0,00'
                        }
                    }
                    this.listOpcoesPagamento.push(array[0])
                    this.listOpcoesPagamento[0].active = true
                    this.opcaoAcordo = this.listOpcoesPagamento[0]
                    console.log('this.listOpcoesPagamento', this.listOpcoesPagamento)
                    this.showOpPagamento = true
                    this.validarFormaCredito = true
                    bus.$emit('load-out')

                }).catch((error) => {
                    bus.$emit('load-out')
                    console.log('erro na fn', error)
                    if(error.response.status === 400) {
                        this.$swal({
                            type: 'error',
                            text: error.response.data.Message
                        })
                        return
                    } else {
                        this.$swal({
                            type: 'error',
                            text: 'Erro nao identificado'
                        })
                    }
                })
            } else {
                console.log('else')
                getOpAcordoPorValor(obj).then(response => {
                    console.log('fez o get')
              
                    let temp = JSON.parse(JSON.stringify(Vuex.state.opAcordo))
                    temp.push(obj)
                    Vuex.commit('SET_OP_ACORDO', temp)
                    if(response.data.length === 0) this.errorFormaPagt()
                    let retorno = response.data 
                    let array = retorno.map(item =>{
                        item.active = false
                        item.expand = false
                        if(obj.acordoCartaoCredito) item.credito = true
                        else item.credito = false
                        return item
                    })
                    if(obj.valorEntrada > 0) {
                        if(Number(obj.qtdParcelas) > 1) {
                            let calc = array[0].descontos.TAC.valor + array[0].descontos.valorAcrescimoCobrado
                            if(obj.valorEntrada < calc) {
                                obj.valorEntrada = 0
                                this.vrEntrada = '0,00'
                                this.$swal({
                                    text: `O valor da entrada não pode ser menor que a soma da TAC com os Acréscimos. Nestas condições o valor mínimo é R$ ${formataNumeroG(calc, '2', ',','.')}.`,
                                    type: 'warning'
                                })
                                bus.$emit('load-out')
                                return

                            }
                        } else {
                            obj.valorEntrada = 0
                            this.vrEntrada = '0,00'
                        }
                    }
                    this.listOpcoesPagamento.push(array[0])
                    this.listOpcoesPagamento[0].active = true
                    this.opcaoAcordo = this.listOpcoesPagamento[0]
                    this.validarFormaCredito = true
                    this.vrAtualizado = formataNumeroG(this.opcaoAcordo.descontos.totalDevido, '2', ',','.')
                    this.showOpPagamento = true
                    console.log('listOpcoesPagamento', this.listOpcoesPagamento)
                    bus.$emit('load-out')
                    // $(document).ready(function(){
                    //     $('[data-toggle="popover"]').popover();
                    // });
                }).catch(() => {
                    bus.$emit('load-out')
                })
            }
        },
        errorFormaPagt(){
            this.$swal({
                text: 'Ops! Nestas condições não conseguimos realizar seu acordo. Por favor, altere a negociação e tente novamente!',
                type: 'warning'
            })
        },
        escolheParcela(item){
            this.listOpcoesPagamento.forEach(e=> e.active = false)
            // for(let i=0; i<this.listOpcoesPagamento.length; i++){
            //     this.listOpcoesPagamento[i].active = false
            // }
            item.active = !item.active
            if(item.active) this.opcaoAcordo = item
        },
        autorizacaoCredito() {
            var data = {
                IdentificacaoPedido: this.divida.CdContrato,
                Cartao: {
                    Bandeira: this.card.codType,
                    Numero: this.card.cardNumber.replace(/ /g, ''),
                    Nome: this.card.cardName,
                    DataExpiracao: this.card.cardMonth + '/' + this.card.cardYear,
                    CodigoSeguranca: this.card.cardCvv
                },
                VrCompra: this.opcaoAcordo.valorTotal,
                NrParcelas: this.opcaoAcordo.plano,
                RespJurosParcelamento: this.card.config.JurosParcelamento,
                DadosTeste: {
                    NrTeste: "1",
                    Captura: "N",
                    SalvaCartao: "S",
                    CancelaTransacao: "N",
                    VrCapturaParcial: 0
                }
            }
            if(data.Cartao.Numero.length !== 16 || data.Cartao.Nome == '' || this.card.cardMonth == '' || this.card.cardYear == '' || this.card.cardCvv == '') {
                this.$swal({
                    type: 'warning',
                    title: 'Preencha todos os campos do cartão corretamente.'
                })
                return
            }
            // console.log('data', JSON.stringify(data))
            try {
                bus.$emit('load-in', {text: 'Carregando'})
                postAutorizacao(data, this.card.config).then(response =>{
                    bus.$emit('load-out')
                    if(response.data.Status == 'Error') {
                        this.$swal({
                            type: 'error',
                            text: response.data.StatusText
                        })
                        return
                    }
                    // console.log("r", response)
                    // return
                    if(response.data.Retorno.AuthorizationCode != null) {
                        this.idAutho = response.data.Retorno.PaymentId
                        this.authorizationCode = response.data.Retorno.AuthorizationCode
                        this.formalizarAcordo()
                    } else {
                        this.$swal({
                            type: 'warning',
                            text: response.data.Retorno.ReturnMessage
                        })
                    }
                })
            } catch(error) {
                this.$swal({
                    type: 'error',
                    text: error.message
                })
            }

        },
        capturaCredito() {
            try {
                postCaptura({PaymentId: this.idAutho}).then(() => {
                    this.baixarAcordoCartao()
                })
            } catch(error) {
                console.log(error)
            }
        },        
        baixarAcordoCartao() {
            let obj = {
                tokenAutorizacao: this.idAutho,
                chaveacordo: this.chaveNegociacao
            }
            this.opcaoAcordo = ''
            bus.$emit('load-in', {text: 'Carregando'})
            postBaixaAcordoCartao(obj).then((r) => {
                bus.$emit('load-out')
                this.acordoCredito = true
                this.showDetalhesAcordo = true


            }).catch((error) => {
                bus.$emit('load-out')
                this.$swal.fire({
                    type: 'error',
                    title: 'Oops...',
                    text: 'Erro ao baixar acordo. ' + error.response.data.Message
                })
                this.acordoCredito = true
                this.showDetalhesAcordo = true

            })
        },
        cancelaCredito() {
            try {
                postCancelamento({PaymentId: this.idAutho}).then(() => {
                })
            } catch(error) {
                console.log(error)
            }
        },
        fecharAcordo(){
            if(this.divida.TermoAceite != 0) {
                let obj = {
                    chaveDivida: this.divida.ChaveDivida,
                    codigo: this.divida.TermoAceite
                }
                bus.$emit('load-in', {text: 'Carregando'})
                getTermoAcordo(obj).then(response => {
                    bus.$emit('load-out')
                    let d = document.getElementById('termo')
                    d.innerHTML = response.data.Retorno
                    this.activeDialog = true
                    setTimeout(() => {
                        let title = document.getElementById('titleDialog')
                        title.focus()
                    }, 500)
                }).catch(() => {
                    bus.$emit('load-out')
                })
            } else {
                this.$swal({
                    title: 'Formalizar o acordo?',
                    type: 'question',
                    allowEscapeKey: true,
                    showConfirmButton: true,
                    confirmButtonText: 'Sim',
                    showCloseButton: true
                    // showCancelButton: true,
                    // cancelButtonText: 'Cancelar',
                    // reverseButtons: true
                }).then(result => {
                    if(result.value) {
                        if(this.formaPgt == 2) this.autorizacaoCredito()
                        else this.formalizarAcordo()
                    } 
                })
            }
        },
        formalizarAcordo(){
            try {
                let obj = {
                    chaveacordo: this.opcaoAcordo.chaveAcordo
                }
                bus.$emit('load-in', {text: 'Carregando'})
                postAcordo(obj).then((retorno) => {
                    bus.$emit('load-out')
                    Vuex.commit('SET_ACORDOS', []) // para carregar a lista atualizada quando a pessoa for em ACORDOS
                    Vuex.commit('SET_DIVIDAS', [])
                    this.chaveNegociacao = retorno.data.Retorno.chaveNegociacao
                    if(this.idAutho !== '') this.capturaCredito()
                    else {
                        this.showDetalhesAcordo = true
                        this.opcaoAcordo = ''
                    } 
                    this.activeDialog = false
                }).catch((error) => {
                    if(this.idAutho !== '') this.cancelaCredito()
                    this.activeDialog = false
                    bus.$emit('load-out')
                    this.$swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: error.response.data.Message
                    })
                })
            } catch(error) {
                if(this.idAutho !== '') this.cancelaCredito()
                this.$swal.fire({
                    type: 'error',
                    title: 'Oops...',
                    text: error.response.data.Message
                })
            }
        }        
    }
}
</script>